export default "__VITE_ASSET__BD7XEyN1__"